import React from "react";
import { DatePicker, Form, Input, Select } from "antd";
import { useDispatch } from "react-redux";
import PhoneNumberMask from "../../../../common/inputs/AuthorizationInputs";
import UploadPhoto from "../../../../common/components/UploadPhoto/UploadPhoto";
import moment from "moment";
import {DELETE_PROFILE_PHOTO, UPLOAD_PROFILE_PHOTO} from "../../api/constants";
import { authUpdateProfileInfo } from "../../../Authorization/redux/actions/GetUser/getUserActions";

const Option = Select.Option;

const ProfileInfoSection = ({ form, disabled, userId }) => {
  const dispatch = useDispatch();
  const { getFieldDecorator, getFieldValue } = form;
  const prefixPhoneCode = getFieldDecorator("phoneCode", {
    initialValue: "+7"
  })(
    <Select
      style={{ width: 80 }}
      disabled={true}
      dropdownMatchSelectWidth={false}
      optionLabelProp="value"
      placeholder="Код"
      getPopupContainer={trigger => trigger.parentNode}
    >
      <Option value="+7">+7 (Россия)</Option>
      <Option value="+380">+380 (Украина)</Option>
      <Option value="+375">+375 (Беларусь)</Option>
      <Option value="+77">+77 (Казахстан)</Option>
      <Option value="+994">+994 (Азербайджан)</Option>
      <Option value="+374">+374 (Армения)</Option>
      <Option value="+995">+995 (Грузия)</Option>
    </Select>
  );
  const updatePhoto = photo => {
    dispatch(authUpdateProfileInfo({ photo }));
  };
  return (
    <React.Fragment>
      <div className="offer-card__item">
        <span className="label">Фамилия:</span>
        <Form.Item>
          {getFieldDecorator("lastname", {
            rules: [
              {
                required: true,
                message: "Поле, обязательное для заполнения"
              }
            ]
          })(
            <Input
              style={{ width: 224 }}
              placeholder="Укажите фамилию"
              disabled={disabled}
            />
          )}
        </Form.Item>
      </div>
      <div className="offer-card__item">
        <span className="label">Имя:</span>
        <Form.Item>
          {getFieldDecorator("name", {
            rules: [
              {
                required: true,
                message: "Поле, обязательное для заполнения"
              }
            ]
          })(
            <Input
              style={{ width: 224 }}
              placeholder="Укажите имя"
              disabled={disabled}
            />
          )}
        </Form.Item>
      </div>
      <div className="offer-card__item">
        <span className="label">Отчество:</span>
        <Form.Item>
          {getFieldDecorator("patronymic")(
            <Input
              style={{ width: 224 }}
              placeholder="Укажите отчество"
              disabled={disabled}
            />
          )}
        </Form.Item>
      </div>
      <div className="offer-card__item">
        <span className="label">Дата рождения:</span>
        <Form.Item>
          {getFieldDecorator("birthDate")(
            <DatePicker
              format={"DD.MM.YYYY"}
              defaultPickerValue={moment().subtract(18, "years")}
              showToday={false}
              placeholder="ДД.ММ.ГГГГ"
              disabled={disabled}
              disabledDate={d => {
                return !moment()
                  .subtract(18, "years")
                  .isAfter(d);
              }}
            />
          )}
        </Form.Item>
        {getFieldValue("birthDate") && (
          <span className="label" style={{ width: "auto" }}>
            {moment(getFieldValue("birthDate")).fromNow(true)}
          </span>
        )}
      </div>
      <div className="offer-card__item">
        <div className="form-item-phone">
          <span className="label">Номер телефона:</span>
          <Form.Item>
            {getFieldDecorator("phoneNumber")(
              <PhoneNumberMask
                autoComplete="off"
                name="phoneNumber"
                mask="(###) ###-##-##"
                maxLength={15}
                addonBefore={prefixPhoneCode}
                disabled={true}
                placeholder="Укажите номер телефона"
                style={{ width: 320 }}
              />
            )}
          </Form.Item>
        </div>
      </div>
      <div className="offer-card__item">
        <span className="label">E-mail:</span>
        <Form.Item>
          {getFieldDecorator("email", {
            rules: [
              {
                required: true,
                message: "Поле, обязательное для заполнения"
              },
              {
                type: "email",
                message: "Не корректный email"
              }
            ]
          })(
            <Input
              style={{ width: 368 }}
              placeholder="Укажите Email"
              disabled={disabled}
            />
          )}
        </Form.Item>
      </div>
      <div
        style={{
          position: "absolute",
          top: 5,
          left: 488,
          zIndex: 1,
          marginRight: 8
        }}
      >
        <Form.Item>
          {getFieldDecorator("photo", {
            rules: [],
            valuePropName: "image_url"
          })(
            <UploadPhoto
              disabled={disabled}
              name={"photo"}
              form={form}
              action={UPLOAD_PROFILE_PHOTO}
              deleteAction={DELETE_PROFILE_PHOTO}
              update={updatePhoto}
            />
          )}
        </Form.Item>
      </div>
    </React.Fragment>
  );
};

export default ProfileInfoSection;
